<template>
  <div class="project item timebird-trade">
    <div class="container custom">
      <div class="project__content list">
        <div class="project__content-breadcrumb" data-aos="fade">
          <el-breadcrumb separator="/">
            <template v-for="(item, index) in routeList">
              <el-breadcrumb-item v-if="item.meta.title" :key="index" :to="{ name: item.name }">
                {{ item.meta.title }}
              </el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </div>
        <div class="list__box">
          <div class="list__box-item" data-aos="fade-up">
            <div class="project__content-title">TimeBird Trade</div>
            <div class="project__content-subtitle">Discover, collect and sell extraordinary NFTs</div>
            <div class="project__content-text">
              The TimeBird Trade is an e-commerce platform based on blockchain technology created to certify, manage and trade NFTs (Non-Fungible Tokens).
              <br>
              Users can ultimately create their NFTs by uploading their creations to the site. The just-created NFT (creation time) will be immutably recorded on TimeBird Chain.
            </div>
            <div class="project__content-button">
              <a href="https://timebird.trade/" target="_blank" class="btn btn-primary">Get started</a>
            </div>
          </div>
          <div class="list__box-item" data-aos="fade" data-aos-delay="500">
            <div class="project__content-image">
              <img class="mw100" src="/assets/images/project/timebird-trade-image.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="project__slide" data-aos="fade" data-aos-delay="300">
      <swiper :options="slideOption" class="project__slide-list">
        <swiper-slide class="list__item">
          <img src="/assets/images/project/timebird-trade-01.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/timebird-trade-02.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/timebird-trade-03.png" alt="">
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination"></div>
      </swiper>
      <p data-aos="fade-up">
        The generated NFTs will be divided into popular categories to help users quickly find the right one for their needs.
      </p>
    </div>
    <div class="project__feature">
      <div class="container custom">
        <div class="project__feature-title" data-aos="fade-up">What do you need to exchange NFTs?</div>
        <div class="project__feature-box">
          <div class="box__content">
            <template v-for="(item, index) in listFeature">
              <div class="box__content-list" data-aos="fade-right" :key="index">
                <div class="list__title" v-if="item.title">
                  <div class="icon">
                    <img src="/assets/images/layouts/icon-star.png" alt="icon">
                  </div>
                  {{ item.title }}
                </div>
                <template v-for="(_item, index) in item.listFeatureItem">
                  <div class="list__item" :key="index">
                    <div class="icon">
                      <img src="/assets/images/layouts/icon-bookmark.png" alt="icon">
                    </div>
                    {{ _item.title }}
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div class="box__image" data-aos="fade-left">
            <img src="/assets/images/project/nft-image.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="project__guide">
      <div class="container custom">
        <div class="project__guide-title" data-aos="fade-up">How to create and sell/buy your NFTs</div>
        <div class="project__guide-step" data-aos="fade" data-aos-delay="500">
          <el-steps :active="active">
            <el-step></el-step>
            <el-step></el-step>
            <el-step></el-step>
          </el-steps>
          <div class="step__progress big">
            <div class="step__progress-item copy" :class="{ active: active === 0 }">
              <img src="/assets/images/project/icon-copy.svg" alt="icon">
            </div>
            <div class="step__progress-item create" :class="{ active: active === 1 }">
              <img src="/assets/images/project/icon-create.svg" alt="icon">
            </div>
            <div class="step__progress-item add" :class="{ active: active === 2 }">
              <img src="/assets/images/project/icon-add.svg" alt="icon">
            </div>
            <div class="step__progress-item sell" :class="{ active: active === 3 }">
              <img src="/assets/images/project/icon-sell.svg" alt="icon">
            </div>
            <div class="step__progress-item buy" :class="{ active: active === 4 }">
              <img src="/assets/images/project/icon-buy.svg" alt="icon">
            </div>
          </div>
          <template v-if="active === 0">
            <div class="step__item">
              <div class="step__item-title">Set up your wallet</div>
              <div class="step__item-content">
                Connect your Defi wallet to TimeNFT
                <br>
                (there are two options to connect with TimeBird Dex or Metamask)
              </div>
            </div>
          </template>
          <template v-if="active === 1">
            <div class="step__item">
              <div class="step__item-title">Create your collection</div>
              <div class="step__item-content">Create your collections so that you can manage your NFTs more accessible and scientific</div>
            </div>
          </template>
          <template v-if="active === 2">
            <div class="step__item">
              <div class="step__item-title">Add your NFTs</div>
              <div class="step__item-content">Upload your creations (image, video, audio, or 3D art) to the web and set a creator fee for future transactions (if any). To put NFT on Blockchain, you must follow the instructions to mint</div>
            </div>
          </template>
          <template v-if="active === 3">
            <div class="step__item">
              <div class="step__item-title">Sell NFTs</div>
              <div class="step__item-content">You can choose to sell NFT at any price you want. NFTs are listed online so other users can easily view and explore them</div>
            </div>
          </template>
          <template v-if="active === 4">
            <div class="step__item">
              <div class="step__item-title">Buy NFTs</div>
              <div class="step__item-content">Select your favorite NFT, click “buy now” and you will easily own NFT. The transaction occurs only a few seconds after you “confirm” to make the payment via the TimeNFT wallet</div>
            </div>
          </template>
        </div>
        <div class="project__guide-button" data-aos="fade">
          <el-button @click="prev" class="button__prev" :class="{ active: active > 0 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
          <el-button @click="next" class="button__next" :class="{ active: active < 4 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      active: 0,
      listFeature: [
        { title: '', listFeatureItem: [
          { title: 'Create an account on the web' },
          { title: 'Own Defi wallet (can choose TimeBird DEX mobile/web wallet)' },
          { title: 'Connect your wallet to TimeNFT' },
        ]},
      ],
      slideOption: {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        speed: 800,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: -20,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
          scale: 0.8
        },
        spaceBetween: 10,
        breakpoints: {
          576: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    routeList () {
      return this.$route.matched
    }
  },
  methods: {
    next() {
      if (this.active++ > 3) this.active = 4;
    },
    prev() {
      if (this.active-- < 1) this.active = 0;
    },
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>